import React from 'react';

const Profile = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.66667 7.33333C8.58714 7.33333 9.33333 6.58714 9.33333 5.66667C9.33333 4.74619 8.58714 4 7.66667 4C6.74619 4 6 4.74619 6 5.66667C6 6.58714 6.74619 7.33333 7.66667 7.33333Z"
        fill="#787F88"
      />
      <path
        d="M7.66667 12.6666C10.4281 12.6666 12.6667 10.4281 12.6667 7.66663C12.6667 4.9052 10.4281 2.66663 7.66667 2.66663C4.90525 2.66663 2.66667 4.9052 2.66667 7.66663C2.66667 10.4281 4.90525 12.6666 7.66667 12.6666Z"
        stroke="#787F88"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.33334 11.3333V9.71827C5.33334 9.15489 5.97194 8.66663 6.70878 8.66663H8.62457C9.41054 8.66663 10 9.15489 10 9.71827V11.3333"
        stroke="#787F88"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Profile;
